import React from 'react';

const PauseIcon = ({fill = '#fff', title = 'Pause icon', className}) => (
    <svg 
        className={`${className}`}
        title={`${title}`}
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 512 512"
    >
        <path 
            fill={`${fill}`} 
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"/>
    </svg>    
);

// Import using: import { PauseIcon } from ...
// Done this way to match the PlayIcon

export { PauseIcon };